import React from 'react'
import { ElementProps } from '../base/element'
import { Item } from '../base/item'
import { DataTableToolbarFunc } from '../helpers/datatableItems'
import { DataTableTable } from './datatableTable'

import { IComponent, IDataComponent, IStyles, ISummaryFunction } from '../schemamanager/types'
import { tablestyle } from './datatableStyles'
import { DataTableCards } from './datatableCards'

export interface IDataTableActions {
  add?: boolean
  copy?: boolean
  edit?: boolean
  delete?: boolean
}


export interface IDataTableOptions {
  toolbarActions?: IDataTableActions
  rowActions?: IDataTableActions
  dragdrop?: boolean
  editOnSingleClick?: boolean
  editOnDoubleClick?: boolean
  rowSelecting?: boolean
  hideTableHeader?: boolean,
  tableStriped?: boolean
  tableBordered?: boolean
}

export interface IDataTableComponent extends IDataComponent {
  type: 'datatable'
  cardView?: boolean,
  detailComponent: IComponent
  summaryCard?: ISummaryFunction
  summaryCellTitle?: ISummaryFunction
  summaryCellValue?: ISummaryFunction
  columns?: string[]
  label?: string
  options?: IDataTableOptions
  styleLabel?: IStyles
  styleHeader?: IStyles
  styleTableContent?: IStyles
  styleCardContent?: IStyles
  styleTable?: IStyles
  styleTableHead?: IStyles
  styleTableHeadRow?: IStyles
  styleTableHeadCell?: IStyles
  styleTableBody?: IStyles
  styleTableRow?: IStyles
  styleTableRowEven?: IStyles
  styleTableRowOdd?: IStyles
  styleCard?: IStyles
  styleCardEven?: IStyles
  styleCardOdd?: IStyles
  styleTableCell?: IStyles
  selectedRowIndex?: number
  editRowIndex?: number
}


const defaultOptions: IDataTableOptions =  {
  toolbarActions: { add: true, copy: true, delete: true },
  rowActions: { edit: true },
  dragdrop: true,
  rowSelecting: true,
  editOnDoubleClick: true,
  tableStriped: true
}

export const DataTable = (props: ElementProps) => {

  const { sm, events, themeColor } = props
  const comp = props.comp as IDataTableComponent
  const style = tablestyle(comp, themeColor)

  if (!comp.options) comp.options = defaultOptions
  if (!comp.options.toolbarActions) comp.options.toolbarActions = defaultOptions.toolbarActions
  if (!comp.options.rowActions) comp.options.rowActions = defaultOptions.rowActions
  // use default on undefined actions
  comp.options = {
    ...defaultOptions,
    ...comp.options
  }

  const showToolbar = (o: IDataTableActions): boolean => !!o.add || !!o.copy || !!o.edit || !!o.delete || !!comp.label

  const toolbar = DataTableToolbarFunc(sm, comp)
  const isModal = comp.detailComponent.type === 'modal'

  const m = props.mergeStyles(style)
  

  return (
    <div {...m.main} {...events()}>
      <div {...m.styleHeader}>
        {!!comp.cardView && showToolbar(comp.options.toolbarActions!) && <Item sm={sm} comp={toolbar}></Item>}
      </div>
      {!!comp.cardView ? <DataTableCards {...props} m={m}/> : <DataTableTable {...props} m={m}/>}
      {isModal && <Item {...props} comp={comp.detailComponent as IComponent} />}
    </div>
  )
}
